import { render, staticRenderFns } from "./seasonGoal.vue?vue&type=template&id=233e0037&scoped=true"
import script from "./seasonGoal.vue?vue&type=script&lang=js"
export * from "./seasonGoal.vue?vue&type=script&lang=js"
import style0 from "./seasonGoal.vue?vue&type=style&index=0&id=233e0037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e0037",
  null
  
)

export default component.exports